<template>
  <div>
    <div class="top new-top blue-text center-flex fw700 mb5">
      <div class="display-flex center-flex">
        <img src="@/assets/images/xinwenzixun@2x.png" alt="" class="icon-rd">
        <span class="fs20 ml10 title-text">新闻动态</span>
      </div>
      <div>
        <GsMore @click="moreClick">更多</GsMore>
      </div>
    </div>
    <div class="newsDetail">
      <div
        class="newsDetail-content gs-card"
        v-for="(item, i) in displayNews"
        :key="i"
      >
        <div class="newsDetail-left">
          <span v-if="String(item.whetherOriginal) === '1'" class="origin-badge">原创新闻</span>
          <img :src="picSrc(item)" alt="" class="pic-img" loading="lazy"/>
        </div>
        <div class="newsDetail-right">
          <div class="newsDetail-title-row">
            <span v-if="String(item.whetherTop)==='1'" class="is-top-badge">置顶</span>
            <div class="newsDetail-right-title hand-cursor" @click="openNewDetail(item)">{{ item.chineseTitle }}</div>
            <div v-if="item.rangeTypeName" class="type-icon">
              {{ item.rangeTypeName.split(',')[0] }}
            </div>
          </div>
          <div class="newsDetail-right-text opa6 ellipsis hand-cursor" @click="openNewDetail(item)">{{ item.digest }}</div>
          <div class="right-bottom">
            <!-- <div>{{ item.areaName }}</div> -->
            <div class="display-flex center-flex">
              <img src="@/assets/images/wangluo-5@2x(1).png" alt="" class="icon-pic" />
              <span class="opa6 ml5">
                素材来源：{{ item.newsSource }}
              </span>
            </div>
            <GsShare
              :id="item.id"
              :title="item.chineseTitle"
              :summary="item.digest"
              :image="prodUrl + item.homePicture"
            />
          </div>
        </div>
      </div>
      <!-- <div class="click-btn">
      <el-button class="click-button" @click="moreClick">
        点击更多新闻
      </el-button>
    </div> -->
    </div>
  </div>
</template>

<script>
import GsShare from '@/components/GsShare/index.vue'
import { P } from '@/router/paths'
export default {
  components: { GsShare },
  data() {
    return {
      prodUrl:"https://shujuzichan.com/xwzx",
    };
  },
  props: {
    newsDetailData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    displayNews() {
      const list = this.newsDetailData || []
      if (typeof window !== 'undefined' && window.innerWidth < 960) {
        return list.slice(0, 6)
      }
      return list
    }
  },
  methods: {
    /** 首页新闻动态位：优先用「新闻动态」类别配图(5:3)，没有再用首页图 */
    picSrc(item) {
      let url = ''
      const raw = item && item.categoryImages
      if (raw) {
        try {
          const map = typeof raw === 'object' ? raw : JSON.parse(String(raw))
          url = (map && map['2']) || ''
        } catch (e) { url = '' }
      }
      if (!url) url = (item && item.homePicture) || ''
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      if (String(url).startsWith('/xwzx/')) return 'https://shujuzichan.com' + url
      return this.prodUrl + url
    },
    moreClick() {
      // window.open('/moreDetail?type=2', "_blank");
      this.$router.push(P.news)
    },
    openNewDetail(item) {
      // this.$router.push({ path: '/NewInfoDetail', query: { id: item.id, title: item.chineseTitle+'详情', isNoList: true  }})
      this.$router.push(P.newsDetail(item.id))
      // window.open('/NewInfoDetail?id='+item.id, "_blank");
    }
  }
};
</script>

<style scoped lang="css">
.newsDetail-content {
  display: flex;
  width: 100%;
  margin-top: 10px;
  min-height: 160px;
  background: linear-gradient( 270deg, #ECF4FF 0%, #FFFFFF 36%, #F2F7FF 63%, #8DBAFF 100%);
  border-radius: 8px;
}
.new-top {
  background-image: url('@/assets/images/矩形@2x.png');
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.icon-rd {
  width: 55px;
  height: 40px;
}
.pic-img{
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.newsDetail-right {
  flex: 1;
  min-width: 0;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.newsDetail-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.type-icon {
  flex: 0 0 auto;
  min-width: 80px;
  height: 24px;
  padding: 0 8px;
  background: linear-gradient( 263deg, #5799FF 0%, #0165FF 100%);
  box-shadow: 2px 2px 4px 0px rgba(46,119,233,0.19);
  border-radius: 4px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: center;
  box-sizing: border-box;
}
.newsDetail-right-title {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 30px;
  font-family: AlibabaPuHuiTi_3_85_Bold;
  font-size: 22px;
  color: #111824;
  line-height: 30px;
}
.newsDetail-right-text {
  margin: 10px;
  flex-shrink: 0;
  height: 72px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.newsDetail-left{
  text-align: center;
  flex-shrink:0;
  width: 246px;
  align-self: stretch;
  position: relative;
  overflow: hidden;
  /* width: 290px; */
}
.right-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 28px;
  height: auto;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 12px;
  color: #111824;
  line-height: 17px;
  text-align: left;
  font-style: normal;
}
.right-bottom > .display-flex {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}
.right-bottom > .display-flex span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-pic {
  width: 12px;
  height: 12px;
}
@media (max-width: 960px) {
  .title-text {
    font-size: 15px;
  }
  .icon-rd {
    width: 34px;
    height: 26px;
  }
  .new-top {
    padding: 8px 2px;
  }
  .newsDetail {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .newsDetail-content {
    flex-direction: column;
    height: auto;
    min-height: 0;
    margin-top: 0;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }
  .newsDetail-content:hover {
    transform: none;
  }
  .newsDetail-left {
    width: 100%;
  }
  .pic-img {
    width: 100%;
    height: 88px;
    object-fit: cover;
  }
  .newsDetail-right {
    padding: 8px;
    gap: 4px;
  }
  .type-icon {
    display: none;
  }
  .newsDetail-right-title {
    font-size: 12px;
    height: auto;
    line-height: 1.35;
    -webkit-line-clamp: 2;
  }
  .newsDetail-right-text {
    margin: 0;
    height: auto;
    font-size: 11px;
    line-height: 1.4;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .right-bottom {
    display: none;
  }
}

.origin-badge {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 24px;
  line-height: 24px;
  padding: 0 10px;
  font-size: 12px;
  color: #fff;
  background: rgba(1, 101, 255, 0.92);
  border-radius: 8px 0 8px 0;
}

.is-top-badge {
  display: inline-block;
  margin-right: 6px;
  padding: 1px 6px;
  font-size: 12px;
  color: #fff;
  background: #D9001B;
  border-radius: 4px;
  vertical-align: middle;
}
</style>